import { Box, Typography } from "@mui/material";
import EnvirormentContent from "../../EnvirormentContent/EnvirormentContent";
import { OwnerDataCups } from "../../../core/models/ownerData/ownerData.model";

interface AutcompleteCupsItemBlockComponentProps {
  ownerDataCup: OwnerDataCups;
}

const AutcompleteCupsItemBlockComponent = ({
  ownerDataCup: { address, envirorment, codeCups },
}: AutcompleteCupsItemBlockComponentProps) => {
  return (
    <Box
      component={"div"}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        overflow:"hidden"
      }}
    >
      <Typography component="p" variant="body1" textOverflow={"ellipsis"} noWrap fontSize={"16px"}>
        {address}
        
      </Typography>
      <Typography component="p" variant="body1" fontSize={"16px"} noWrap>
        <EnvirormentContent
          service={envirorment}
          variant={"body1"}
          showServiceText={false}
        />{" "}
       {codeCups}
      </Typography>
    </Box>
  );
};

export default AutcompleteCupsItemBlockComponent;
